namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class RunBookDialog extends SiteEntityDialog<RunBookRow, any> {
        protected getFormKey() { return RunBookForm.formKey; }
        protected getIdProperty() { return RunBookRow.idProperty; }
        protected getLocalTextPrefix() { return RunBookRow.localTextPrefix; }
        protected getNameProperty() { return RunBookRow.nameProperty; }
        protected getService() { return RunBookService.baseUrl; }
        protected getDeletePermission() { return RunBookRow.deletePermission; }
        protected getInsertPermission() { return RunBookRow.insertPermission; }
        protected getUpdatePermission() { return RunBookRow.updatePermission; }

        protected form = new RunBookForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.setStatusCode();
            this.setDependency();
        }

        protected setStatusCode() {
            if ($(".status").length < 1) {
                $('<p class="status"></p>')
                    .insertAfter(this.form.StatusCode.element)
            }
            $(".status").html(this.getStatusCode(this.form.StatusCode.value));
            if (this.form.StatusCode.value)
                this.form.StatusCode.getGridField().children('.editor').hide();
            else
                this.form.StatusCode.getGridField().toggle(false);
        }

        protected setDependency() {
            var lookup = Q.getLookup("Workflow.ClientFunctionName");
            $(".s-LookupEditor").html(this.selectFormatter(lookup));
            $(".fname").val(this.form.FunctionName.value);
            if ($(".dep").length < 1) {
                $('<p class="dep" style="text-align: center;"><span style="text-align: center; width: 30px; height:23px; font-size: 23px; display: inline-block; cursor: pointer" class="fa fa-plus-square" aria-hidden="true"></span></p>')
                    .insertAfter(this.form.Dependencies.element)
                    .click(() => this.loadDependencies());
            }
            if (!this.isNew()) {
                this.editFields($(".dep"), true);
                this.editFields($(".fname"), true);
            }
            if (!this.isViewMode()) {
                this.editFields($(".dep"), false);
                this.editFields($(".fname"), false);
            }
        }

        protected getStatusCode(statusCode: string) {
            if (!statusCode)
                return "";
            var color;
            if (statusCode === "SUCCEEDED")
                color = "green";
            else if (statusCode.indexOf("FAIL") >= 0 || statusCode.replace(/ /g, "")  === "NOTREADY")
                color = "red";
            else
                color = "amber";
            return `<span class="text-${color}"><i class="fa fa-circle"> ${Q.htmlEncode(statusCode)}</span>`;
        }

        private loadDependencies() {
            new RunBookPickerDialog({
                stepId: this.form.StepId.value
            }).dialogOpen();
        }

        protected updateInterface() {
            let that = this;
            super.updateInterface();
            $(".ForceTriggerEnabled").click(function () {
                var ent = that.getSaveEntity();
                if (ent.ForceTriggerEnabled == false) {
                    that.editFields($(".ForceTrigger"), true);
                } else {
                    that.editFields($(".ForceTrigger"), false);
                }
            });
            if (this.isNew()) {
                that.enableDisableFields(false);
                that.editFields($(".ForceTrigger"), true);
            } else {
                that.enableDisableFields(true);
                if (!this.isViewMode()) {
                    this.cloneButton && this.cloneButton.hide();
                    that.enableDisableFields(false);
                    var entity = that.getSaveEntity();
                    if (entity.ForceTriggerEnabled == true) {
                        that.editFields($(".ForceTrigger"), false);
                    } else {
                        that.editFields($(".ForceTrigger"), true);
                    }
                }
            }
        }

        protected enableDisableFields(flag: boolean) {
            $(".fname").toggleClass('disabled', flag)
            $(".dep").toggleClass('disabled', flag)
            $(".ForceTrigger").toggleClass('disabled', flag)
            $(".ForceTriggerEnabled").toggleClass('disabled', flag)
            $(".Enabled").toggleClass('disabled', flag)
        }

        private selectFormatter(lookup: Q.Lookup<any>) {
            var markup = " <input size='75' class='fname' type='text' list = 'functions' /><datalist id='functions'>"
            for (var c of lookup.items) {
                let id = c[lookup.idField];
                markup += "<option> " + Q.htmlEncode(c[lookup.textField]) + " </option>";
            }
            return markup + "</datalist>";
        }

        protected getToolbarButtons() {
            var btns = super.getToolbarButtons();
            var btnSave = Q.first(btns, x => x.cssClass == "save-and-close-button");
            var btnApply = Q.first(btns, x => x.cssClass == "apply-changes-button");
            var oldSaveClick = btnSave.onClick;
            var oldApplyClick = btnApply.onClick;
            btnSave.onClick = e => { this.editBeforeSave(oldSaveClick, e); };
            btnApply.onClick = e => { this.editBeforeSave(oldApplyClick, e); };
            return btns;
        }

        private editBeforeSave(oldEvt, e) {
            var fname = $(".fname").val();
            $("[name='FunctionName']").val(fname);
            oldEvt(e);
        }
 
        protected editFields(element: JQuery, flag: boolean) {
            element.toggleClass('disabled', flag);
        }
    }
}